// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AccountSource = { accountId?: string; amount?: any; [key: string]: any };

// AEX-3218: overlays the balances edited in the Update Balances modal onto `sources`, matched by accountId, so
// every other account (and field) keeps the data in `sources`. Returns null when an edited account is no longer
// in `sources` (the plan changed since the modal was opened), so the edits are applied all or nothing.
// Returns a new array; the inputs are not mutated.
export const applyEditedBalances = (
    sources: AccountSource[] = [],
    editedAccounts: AccountSource[] = []
): AccountSource[] | null => {
    const editedAmountById = new Map(
        editedAccounts.filter((account) => account?.accountId).map((account) => [account.accountId, account.amount])
    );
    const sourceIds = new Set(sources.map((source) => source?.accountId));
    if (Array.from(editedAmountById.keys()).some((accountId) => !sourceIds.has(accountId))) return null;
    return sources.map((source) =>
        source?.accountId && editedAmountById.has(source.accountId)
            ? { ...source, amount: editedAmountById.get(source.accountId) }
            : source
    );
};
